<div class="info">
  <div class="content responsive-row">
    <div>
      <h2 class="mat-h1">{{ 'appvertise.first_line' | translate }}&nbsp;</h2>
      <h2 class="mat-h1">{{ 'appvertise.second_line' | translate }}</h2>
      <h3 class="mat-h5">
        <span>{{ 'appvertise.third_line' | translate }}</span>
      </h3>
      <p>{{ 'appvertise.fourth_line' | translate }}</p>
      <p>
        <a href="{{ 'general.link_to_google_store' | translate }}">
          <img
            class="store-svg"
            alt="{{ 'a11y.link.to_google_store' | translate }}"
            src="assets/images/google_play_badge.svg" />
        </a>
        &nbsp;
        <a href="{{ 'general.link_to_apple_store' | translate }}">
          <img
            class="store-svg"
            alt="{{ 'a11y.link.to_apple_store' | translate }}"
            src="assets/images/apple_store_badge.svg" />
        </a>
      </p>
    </div>
    <img src="assets/images/mobile-dummy.png" alt="" />
  </div>
</div>
